class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

    open(triggeredBy) {
        if (triggeredBy) { this.setActiveElement(triggeredBy); this.refresh(); }
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    
        // Ensure animation is triggered
        setTimeout(() => {
            this.classList.add('animate', 'active');
        });
    
        // this.addEventListener(
        //     'transitionend',
        //     () => {
        //         const containerToTrapFocusOn = this.classList.contains('is-empty')
        //             ? this.querySelector('.drawer__inner-empty')
        //             : document.getElementById('CartDrawer');
        //         const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        //         trapFocus(containerToTrapFocusOn, focusElement);
        //     },
        //     { once: true }
        // );
    
        document.body.classList.add('overflow-hidden');
    
        // Swipe detection for closing the drawer
        // const drawer = this;
        // let startX = 0;
    
        // const touchStartHandler = (event) => {
        //     startX = event.touches[0].clientX;
        // };
    
        // const touchEndHandler = (event) => {
        //     const endX = event.changedTouches[0].clientX;
        //     if (endX - startX > 50) {
        //         drawer.classList.remove('active');
        //     }
        // };
    
        // if (!this.swipeListenersAdded) {
        //     this.addEventListener('touchstart', touchStartHandler);
        //     this.addEventListener('touchend', touchEndHandler);
        //     this.swipeListenersAdded = true;
        // }
          document.documentElement.style.overflowY = 'hidden';
    }
    
    close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
      document.documentElement.style.overflowY = '';
    }
  
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  async refresh() {
    const request = (this.refreshRequest || 0) + 1;
    this.refreshRequest = request;
    try {
      const response = await fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`);
      if (!response.ok) throw new Error('Cart refresh failed');
      const sections = await response.json();
      if (request !== this.refreshRequest) return;
      this.renderContents({ sections }, false);
    } catch (error) {
      const errors = this.querySelector('#CartDrawer-CartErrors');
      if (errors) errors.textContent = window.cartStrings.error;
    }
  }

  renderContents(parsedState, shouldOpen = true) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (sectionElement && parsedState.sections?.[section.id]) sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.classList.toggle('is-empty', Boolean(this.querySelector('.drawer__inner-empty')));
      if (shouldOpen) this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: 'cart-drawer-items',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.cart-drawer__footer',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.cart-drawer__subscription',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: 'free-shipping-bar',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

